export default __webpack_public_path__ + "7efda7b810ddfb8a8b931093d5d2688f.woff2";